






















































































import { Component, mixins, Prop } from 'nuxt-property-decorator'
import Plan from '~/models/plan'
import DefaultImage from '~/mixins/defaultImage'
import { checkHideHomePricing } from '~/utils/plans'
import globalStyling from '~/mixins/globalStyling'
import projectConfig from '~/assets/project-config.json'

@Component({
  mixins: [DefaultImage, globalStyling],
})
export default class PlanCardV3 extends mixins(globalStyling) {
  @Prop({ default: (): any => null })
  plan!: Plan

  @Prop({ default: false }) showBuilderName!: boolean
  @Prop({ default: null }) floor: number
  @Prop({ default: false }) isCondo: boolean

  defaultImage!: () => string

  get imageSrc(): string {
    return this.plan?.image || this.defaultImage()
  }

  get hideHomePricing(): boolean {
    return checkHideHomePricing(this.plan)
  }

  get storyFloorTitle(): string {
    if (this.floor && this.isCondo) {
      return 'Floor'
    }
    return this.plan.stories <= 1 ? 'Story' : 'Stories'
  }

  get showStoryFloor(): boolean {
    const configEnabled =
      this.getStyleVariableValue('--ad-sp-pc-story-floor')?.replace(
        /['"]+/g,
        ''
      ) === 'true'
    return configEnabled && (!!this.plan.stories || !!this.floor)
  }

  get planCardPriceLabel(): string {
    if (!this.isCondo) {
      return (
        projectConfig[this.$route.params.slug]?.homesitePlanCardPriceLabel ||
        'Starting at'
      )
    }
    return 'Starting at'
  }
}
